<ts-dialog [title]="title" (closeDialog)="dialogRef.close()">
  <div ts-dialog-body>
    <form class="w-full flex flex-col gap-2" [formGroup]="categoryAccountForm">
      @if (categoryAccountOptions$ | async; as categoryAccountOptions) {
        <span class="flex flex-row items-center justify-between">
          <p class="flex flex-row items-center gap-0.5 required">Name</p>
          <ts-input
            placeholder="Account name"
            class="w-1/2"
            type="text"
            [formControl]="categoryAccountFormControls.name"
            [roundedBorders]="false"
          ></ts-input>
        </span>
        <span class="flex flex-row items-center justify-between">
          <p>Description</p>
          <ts-input
            placeholder="Account description"
            class="w-1/2"
            type="text"
            [formControl]="categoryAccountFormControls.description"
            [roundedBorders]="false"
          ></ts-input>
        </span>
        <ng-container
          *ngTemplateOutlet="
            selectField;
            context: {
              title: 'Normal Balance',
              formControl: categoryAccountFormControls.normal_balance,
              options: CategoryAccountUtils.normalBalanceOptions,
            }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            selectField;
            context: {
              title: 'Parent Account',
              formControl: categoryAccountFormControls.parent_id,
              options: categoryAccountOptions,
            }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            selectField;
            context: {
              title: 'Report Type',
              formControl: categoryAccountFormControls.report_type,
              options: CategoryAccountUtils.reportTypeOptions,
            }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            selectField;
            context: {
              title: 'Account Type',
              formControl: categoryAccountFormControls.account_type,
              options: CategoryAccountUtils.accountTypeOptions,
            }
          "
        ></ng-container>
      } @else {
        <ts-skeleton height="56"></ts-skeleton>
        <ts-skeleton height="36"></ts-skeleton>
      }
    </form>

    @if (categoryAccountFormControls.account_type.value === 'total') {
      <form class="mt-6">
        <div class="flex flex-row justify-between mb-4">
          <p>
            Accounts to Aggregate&nbsp;
            @if (totalAggregatesFormArray.length === 6) {
              <span class="text-cool-gray-300 italic">Limit reached</span>
            }
          </p>

          @if (totalAggregatesFormArray.length < 6) {
            <ts-icon
              class="cursor-pointer poi"
              [ngClass]="{ 'cursor-default pointer-events-none': totalAggregatesFormArray.invalid }"
              [color]="totalAggregatesFormArray.invalid ? 'light-gray' : 'black'"
              icon="add_circle_outline"
              (click)="addAggregatedAccountForm()"
            ></ts-icon>
          }
        </div>

        @for (accountForm of totalAggregatesFormArray.controls; track $index) {
          <div class="mb-2 flex flex-row justify-between gap-2">
            <ng-container
              *ngTemplateOutlet="
                selectField;
                context: {
                  title: $index + 1,
                  formControl: accountForm,
                  options:
                    categoryAccountOptions$
                    | async
                    | filterBy: ['value'] : accountForm.value : filterPreselectedCategories.bind(this),
                }
              "
            ></ng-container>
            <ts-icon class="cursor-pointer" icon="ts_trash-alt" (click)="removeAggregatedAccountForm($index)" />
          </div>
        }
      </form>
    }
  </div>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="dialogRef.close()">Cancel</ts-button>
    <ts-button variant="primary" [disabled]="!isSubmitable" (click)="submitForm()">Save</ts-button>
  </div>
</ts-dialog>

<ng-template
  #selectField
  let-title="title"
  let-formControl="formControl"
  let-placeholder="placeholder"
  let-options="options"
>
  <div class="flex flex-row items-center justify-between w-full">
    <p
      class="flex flex-auto flex-row items-center gap-0.5"
      [ngClass]="{ required: formControl.hasValidator(Validators.required) }"
    >
      {{ title }}
    </p>
    <ts-select
      itemKey="value"
      itemLabel="label"
      [formControl]="formControl"
      class="w-1/2"
      [hasGroups]="false"
      [uiOptions]="{
        roundedBorders: false,
        placeholder: placeholder || 'Select...',
        searchPlaceholder: 'Search...',
        size: 'full',
      }"
      [items]="options"
    ></ts-select>
  </div>
</ng-template>
